NtechApp.LightBox = function($itemsWrapper, settings) {
    var me = this;

    me._click = null;

    me._$itemsWrapper = null;
    me._lightbox = null;

    me._loader = null;
    me._overlay = null;

    this._disableOverlayShow = false;
    this._showCaption = false;

    var getSetting = function(settings, name) {
        if(NtechApp.dom.hasOwnProp(settings, name))
            return settings[name];
        else
            return undefined;
    };

    this._construct = function () {
        me._click = new NtechApp.TouchClickEvent();
        me._$itemsWrapper = $itemsWrapper;

        me._disableOverlayShow = getSetting(settings, "disableOverlay") || false;
        me._showCaption = getSetting(settings, "showCaption") || false;

        me._loader = new NtechApp.Loader();
        me._overlay = new NtechApp.Overlay();

        var loaderCss = getSetting(settings, "loaderCss") || false;
        if(loaderCss)
            me._loader.updateCss(loaderCss);

        me._create();

        me._bindEvents();
    };

    this._bindEvents = function () {
    };

    this._unbindEvents = function () {
        ;
    };

    this.destruct = function () {
        me._unbindEvents();
    };

    this._construct();
    return this;
};

NtechApp.LightBox.EVENT_ON_OPEN = "NtechApp.LightBox.EventOnOpen";
NtechApp.LightBox.EVENT_ON_CLOSE = "NtechApp.LightBox.EventOnClose";

NtechApp.proto(NtechApp.LightBox, {
    destroy: function() {
        this._lightbox.destroy();
    },

    _create: function() {
        var me = this;

        this._lightbox = this._$itemsWrapper.find("[data-lightboxImage]").imageLightbox({
            quitOnDocClick: false,
            onLoadStart: function() { 
                me._enableLoader(); 
            },
            onLoadEnd: function() { 
                me._disableLoader(); 
                me._updateCaption();
            },
            onStart: function() {  
                $(me).trigger(NtechApp.LightBox.EVENT_ON_OPEN);

                me._enableOverlay(); 
                me._createCaption(); 
                me._createCloseButton(me._lightbox); 
                me._createArrows(me._lightbox); 
            },
            onEnd: function() { 
                $(me).trigger(NtechApp.LightBox.EVENT_ON_CLOSE);

                me._disableOverlay(); 
                me._deleteCaption(); 
                me._deleteCloseButton(); 
                me._deleteArrows(); 
            }
        });
    },

    _enableLoader: function() { this._loader.on(); },
    _disableLoader: function() { this._loader.off(); },
    _enableOverlay: function() { if(this._disableOverlayShow) return; this._overlay.on(); },
    _disableOverlay: function() { if(this._disableOverlayShow) return; this._overlay.off(); },

    _createCaption: function() {
        if(!this._showCaption) return;

        $("<div id='imagelightboxCaption'></div>'").appendTo("body");
        $("<div class='content'></div>").appendTo("#imagelightboxCaption");
        $("<div class='headingIcon'></div>").appendTo("#imagelightboxCaption .content");
        //$("<img/>").attr("src", "/bundles/ntechclient/img/icons/products.png").appendTo("#imagelightboxCaption .headingIcon");
        $("<div class='heading headingFont'></div>").appendTo("#imagelightboxCaption .content");
        $("<div class='description'></div>").appendTo("#imagelightboxCaption .content");
        $("<div class='price headingFont'></div>").appendTo("#imagelightboxCaption .content");
    },

    _deleteCaption: function() {
        if(!this._showCaption) return;

        $("#imagelightboxCaption").removeClass("visible");
        var oldCaption = document.getElementById("imagelightboxCaption");
        if(oldCaption == null)
            return;
        oldCaption.removeAttribute("id");

        setTimeout(function() {
            $(oldCaption).remove();
            //if(oldCaption.length > 0)
            //    $("#imagelightboxCaption").remove();
        }, 500);
        //$("#imagelightboxCaption").animate({opacity: 0}, 250, function() { $("#imagelightboxCaption").remove(); });
    },

    _updateCaption: function() {
        if(!this._showCaption) return;

        var $currentItem = this._$itemsWrapper.find("a[href='" + $("[data-lightboxImage]").attr('src') + "'] img");
        $("#imagelightboxCaption .heading").text($currentItem.attr("data-image-heading"));
        $("#imagelightboxCaption .description").text($currentItem.attr("data-image-description"));
        $("#imagelightboxCaption .price").text($currentItem.attr("data-image-price")).css({"color": "white"});
        $("#imagelightboxCaption").css("display", "block");

        setTimeout(function() {
            if($("#imagelightboxCaption").length > 0)
                $("#imagelightboxCaption").addClass("visible");
        }, 100);
        //$("#imagelightboxCaption").addClass("visible");
    },

    _createCloseButton: function(instance) {
        var me = this;

        $("<div id='imagelightboxCloseButton'>CLOSE</div>").appendTo("body");
        me._click.listen($("#imagelightboxCloseButton"), function(event) {
            me._disableOverlay();
            me._deleteCaption();
            me._deleteCloseButton();
            me._deleteArrows();
            instance.quitImageLightbox();
            
            return false;
        });
    },

    _deleteCloseButton: function() {
        $("#imagelightboxCloseButton").remove();
    },

    _createArrows: function(instance) {
        var me = this;

        $("<div id='imagelightboxLeftArrowButton'><div class='arrowWrapper'><div class='arrow'></div></div></div>").appendTo("body");
        $("<div id='imagelightboxRightArrowButton'><div class='arrowWrapper'><div class='arrow'></div></div></div>").appendTo("body");

        me._click.listen($("#imagelightboxLeftArrowButton"), function() {
            instance.loadImage("left");
        });
        me._click.listen($("#imagelightboxRightArrowButton"), function() {
            instance.loadImage("right");
        });
    },

    _deleteArrows: function() {
        $("#imagelightboxLeftArrowButton").remove();
        $("#imagelightboxRightArrowButton").remove();
    }
});